import { createAction } from '@reduxjs/toolkit';
import { AiInstructionFilters, IntentFilters } from 'api/types';
import { WidgetInitMethod } from 'reducers/config';

export const ConfigureAppActions = {
  ADD_RAW_PARAMS: 'add/rawParams',
  SET_AI_INSTRUCTIONS_FOR_PREVIEW: 'set/aiInstructionsForPreview',
  SET_API_KEY: 'set/apiKey',
  SET_INTENT_FILTERS_FOR_PREVIEW: 'set/setIntentFiltersForPreview',
  SET_ORIGIN: 'set/origin',
  SET_PREVIEW_IS_LIVE_MODE: 'set/previewIsLiveMode',
  SET_RAW_PARAMS: 'set/rawParams',
  SET_WIDGET_INIT_METHOD: 'set/widgetInitMethod',
} as const;

const setAPIKey = createAction<string>(ConfigureAppActions.SET_API_KEY);
const setIntentFiltersForPreview = createAction<IntentFilters>(
  ConfigureAppActions.SET_INTENT_FILTERS_FOR_PREVIEW,
);
const setPreviewIsLiveMode = createAction<boolean>(
  ConfigureAppActions.SET_PREVIEW_IS_LIVE_MODE,
);
const setAiInstructionsForPreview = createAction<AiInstructionFilters[]>(
  ConfigureAppActions.SET_AI_INSTRUCTIONS_FOR_PREVIEW,
);
const setOrigin = createAction<string>(ConfigureAppActions.SET_ORIGIN);
const addRawParams = createAction<{ [attrName: string]: string | boolean }>(
  ConfigureAppActions.ADD_RAW_PARAMS,
);
const setRawParams = createAction<{
  [attrName: string]: string | boolean;
}>(ConfigureAppActions.SET_RAW_PARAMS);
const setWidgetInitMethod = createAction<WidgetInitMethod>(
  ConfigureAppActions.SET_WIDGET_INIT_METHOD,
);

export {
  setAPIKey,
  setOrigin,
  addRawParams,
  setRawParams,
  setIntentFiltersForPreview,
  setPreviewIsLiveMode,
  setWidgetInitMethod,
  setAiInstructionsForPreview,
};
